.uic-radio {
    /**
    
    @prop --uic-radio-indicator-outer-size: the size of the indicator container 
    @prop --uic-radio-indicator-inner-size: the size of the checked indicator 
    
    */

    display: inline;
    padding: 4px 8px;
    outline: 0;

    &:hover,
    &:active,
    &:focus-visible {
        .uic-radio__label,
        .uic-radio__icon {
            color: var(--uic-color-blue3);
        }

        .uic-radio__indicator {
            border-color: var(--uic-color-blue2);
        }
    }

    &:active .uic-radio__indicator {
        background: var(--uic-color-blue0a40);
    }

    &:focus-visible .uic-radio__indicator {
        border: 2px solid var(--uic-color-blue2);
    }

    &__control {
        display: inline-flex;
        flex-flow: row nowrap;
        align-items: center;
        position: relative;
        cursor: pointer;
        user-select: none;
        min-height: 40px;
    }

    &__indicator {
        box-sizing: border-box;
        width: var(--uic-radio-indicator-outer-size);
        height: var(--uic-radio-indicator-outer-size);
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid var(--uic-color-grey2);
        background: var(--uic-color-white);

        &::after {
            content: "";
            display: block;
            border-radius: 50%;

            width: var(--uic-radio-indicator-inner-size);
            height: var(--uic-radio-indicator-inner-size);
        }
    }

    &__input {
        @include visually-hidden();
    }

    &__label {
        @include font(normal);
        color: var(--uic-color-black);
        display: flex;
        align-items: center;
        gap: 8px;

        &:not(:empty) {
            margin-left: 10px;
        }
    }

    &__icon {
        color: var(--uic-color-grey3);
    }

    &--checked {
        .uic-radio__indicator {
            border-color: var(--uic-color-blue2);

            &::after {
                background: var(--uic-color-blue4);
            }
        }

        &:active {
            .uic-radio__indicator {
                background: var(--uic-color-blue0a40);
            }
        }

        &:active,
        &:hover {
            .uic-radio__indicator::after {
                background: var(--uic-color-blue3);
            }
        }

        &:focus-visible .uic-radio__indicator::after {
            background: var(--uic-color-black);
        }
    }

    &--disabled {
        pointer-events: none;

        .uic-radio__indicator {
            border-color: var(--uic-color-grey2a25);
        }

        &.uic-radio--checked {
            .uic-radio__indicator::after {
                background: var(--uic-color-blacka50);
            }
        }

        .uic-radio__label {
            color: var(--uic-color-grey3a75);
        }

        .uic-radio__icon {
            color: var(--uic-color-grey5);
        }
    }
}
